'use client'

import React, { useEffect } from 'react'
import QRCode from 'qrcode.react'
import { useParams, usePathname, useSearchParams } from 'next/navigation'

import { getSourceDomainFromUrlPath } from '@/core/lib'
import { isBrowser } from '@/utils/common'

interface Props {
  size?: number
  level?: 'L' | 'M' | 'Q' | 'H'
  bgColor?: string
  'aria-label'?: string
  id?: string
}

/**
 * @component DownloadQrcode
 * @description
 * 현재 페이지의 URL과 props로 받은 정보를 query string으로 변환하여 QR코드를 생성합니다.
 * QR 코드를 통해 src/pages/redirect-qr 페이지로 이동하며
 * /redirect-qr 페이지에서는 사용자를 대상으로
 * airbridge 앱 혹은 앱 다운로드 페이지로 리다이렉트 합니다.
 */
const DownloadQrcode: React.FC<Props> = (props) => {
  const [url, setUrl] = React.useState('')

  const pathname = usePathname()
  const params = useParams()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!pathname || !isBrowser()) return
    const url = new URL('/redirect-qr', location.origin)

    /* DownloadQrcode가 위치한 page의 location 환경의 정보를 넘깁니다. */
    if (params) {
      for (const key in params) {
        url.searchParams.set(key, params[key] as string)
      }
    }

    if (searchParams) {
      for (const [key, value] of searchParams) {
        url.searchParams.set(key, value)
      }
    }

    if (pathname.startsWith('/jp')) {
      url.searchParams.set('country', 'jp')
    }

    /* Airbridge Install Url 형성할 때 필요한 domain(의사, 병원 등) 정보를 전달합니다. */
    const sourceDomain = getSourceDomainFromUrlPath(pathname)
    if (sourceDomain) {
      url.searchParams.set('sourceDomain', sourceDomain)
    }

    setUrl(url.href)
  }, [pathname, params, searchParams])

  if (!url) return <></>
  return (
    <QRCode
      id={props.id}
      value={url}
      onClick={() => {
        // on new tab
        window.open(url, '_blank')
      }}
      {...props}
    />
  )
}

export default DownloadQrcode
